export const getTemplateDetailEditPath = templateId => `/templates/${templateId}/edit`;
export const getTemplateDetailDocumentPreviewPath = templateId => `/templates/${templateId}/document_preview`;
export const getTemplatesListPath = () => '/templates';
export const getTemplateDetailPath = templateId => `/templates/${templateId}`;

export default null;
